export const entryCourseSlugQueryParam = 'entryCourseSlug'
export const legacyEntryCourseSlugQueryParam = 'entry'

export function resolveEntryCourseSlug(
	value: string | null | undefined,
): string | undefined {
	if (typeof value !== 'string') return undefined
	const normalized = value.trim()
	return normalized.length > 0 ? normalized : undefined
}

export function resolveEntryCourseSlugFromSearchParams(
	searchParams: URLSearchParams,
): string | undefined {
	return (
		resolveEntryCourseSlug(searchParams.get(entryCourseSlugQueryParam)) ??
		resolveEntryCourseSlug(searchParams.get(legacyEntryCourseSlugQueryParam))
	)
}

export function appendEntryCourseSlug(
	searchParams: URLSearchParams,
	entryCourseSlug: string | null | undefined,
) {
	const resolved = resolveEntryCourseSlug(entryCourseSlug)
	if (!resolved) return
	searchParams.set(entryCourseSlugQueryParam, resolved)
}
